import React, { useEffect, useState } from "react";
import "./Information.scss";
import {
  homeFgStockData,
  homeOrderData,
  homeoutrStandData,
  homeSaleData,
} from "../../../Recoil/atom";
import { useRecoilState } from "recoil";

const Information = () => {
  const [saleData, setSaleData] = useRecoilState(homeSaleData);
  const [orderData, setOrderData] = useRecoilState(homeOrderData);
  const [outStandingData, setStandingData] = useRecoilState(homeoutrStandData);
  const [fgStockData, setFgStockData] = useRecoilState(homeFgStockData);

  const formatAmount = (amount) => {
    if (amount >= 1000000) {
      return (amount / 1000000).toFixed(1) + "M";
    } else if (amount >= 1000) {
      return (amount / 1000).toFixed(1) + "K";
    } else {
      return amount?.toString();
    }
  };

  const roundFigure = (value) => {
    return value ? Math.round(value) : 0;
  };

  useEffect(() => {
    const storedSaleData = sessionStorage.getItem("saleData");
    const storedOrderData = sessionStorage.getItem("orderData");
    const storedOutStandingData = sessionStorage.getItem("outStandingData");
    const storedFgStockData = sessionStorage.getItem("fgStockData");
    if (
      storedSaleData &&
      storedOrderData &&
      storedOutStandingData &&
      storedFgStockData
    ) {
      setSaleData(JSON.parse(storedSaleData));
      setOrderData(JSON.parse(storedOrderData));
      setStandingData(JSON.parse(storedOutStandingData));
      setFgStockData(JSON.parse(storedFgStockData));
    }
  }, []);

  return (
    <div>
      <div className="information_mainDiv">
        {saleData && (
          <div className="TopBox1">
            <p className="Info_box_Maintitle">
              <span>Today</span> Sale
            </p>
            <div className="Info_box_Sub_Main_new">
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <p className="Info_box_InfoP">
                  <span className="infor_sub_infor">
                    {roundFigure(saleData?.GrossWt)}{" "}
                  </span>
                  GW
                </p>
                <p className="Info_box_InfoP_right">
                  <span className="infor_sub_infor">{saleData?.JobCount}</span>
                  JobNo
                </p>
              </div>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <p className="Info_box_InfoP">
                  <span className="infor_sub_infor">
                    {roundFigure(saleData?.NetWt)}{" "}
                  </span>
                  NW
                </p>

                <p className="Info_box_InfoP_right">
                  <span className="infor_sub_infor">
                    {formatAmount(saleData?.Amount) ?? 0}
                  </span>
                  Amount
                </p>
              </div>
            </div>
          </div>
        )}

        {orderData && (
          <div className="TopBox2">
            <p className="Info_box_Maintitle">
              <span>Today</span> Order
            </p>
            <div className="Info_box_Sub_Main_new">
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <p className="Info_box_InfoP">
                  <span className="infor_sub_infor">
                    {roundFigure(orderData?.T_Gwt)}{" "}
                  </span>
                  GW
                </p>
                <p className="Info_box_InfoP_right">
                  <span className="infor_sub_infor">
                    {orderData?.Qut_Job ?? 0}
                  </span>
                  JobNo
                </p>
              </div>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <p className="Info_box_InfoP">
                  <span className="infor_sub_infor">
                    {roundFigure(orderData?.T_Nwt)}
                  </span>
                  NW
                </p>
                <p className="Info_box_InfoP_right">
                  <span className="infor_sub_infor">
                    {formatAmount(orderData?.T_Amt) ?? 0}
                  </span>
                  Amount
                </p>
              </div>
            </div>
          </div>
        )}

        {outStandingData && (
          <div className="TopBox3">
            <p className="Info_box_Maintitle">Outst.</p>
            <div className="Info_box_Sub_Main">
              <div>
                <p className="Info_box_InfoP">
                  <span className="infor_sub_infor">
                    {outStandingData?.PayableAmount?.toLocaleString() ?? 0}
                  </span>
                  Payable Amount
                </p>
                <p className="Info_box_InfoP">
                  <span className="infor_sub_infor">
                    {outStandingData?.ReceivableAmount?.toLocaleString() ?? 0}
                  </span>
                  Receivable Amount
                </p>
              </div>
            </div>
          </div>
        )}

        {fgStockData && (
          <div className="TopBox4">
            <p className="Info_box_Maintitle">FgStock</p>
            <div className="Info_box_Sub_Main">
              <div>
                <p className="Info_box_InfoP">
                  <span className="infor_sub_infor">
                    {roundFigure(fgStockData?.GrossWt)}{" "}
                  </span>
                  GW
                </p>
                <p className="Info_box_InfoP">
                  <span className="infor_sub_infor">
                    {roundFigure(fgStockData?.NetWt)}{" "}
                  </span>
                  NW
                </p>
              </div>
              <div>
                <p className="Info_box_InfoP">
                  <span className="infor_sub_infor">
                    {fgStockData?.JobCount ?? 0}
                  </span>
                  JobNo
                </p>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Information;
